import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { UserRound, ChevronDown } from "lucide-react";
import PressInquiryForm from "../components/PressInquiryForm";

function StaffCard({ c, i }) {
    const [open, setOpen] = useState(false);
    const hasBio = !!(c.bio && c.bio.trim());
    return (
        <div
            className="card-flat overflow-hidden group"
            data-testid={`coach-card-${i}`}
        >
            <div className="aspect-square relative bg-bg-soft overflow-hidden">
                {c.photo_url ? (
                    <div
                        className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                        style={{ backgroundImage: `url('${c.photo_url}')` }}
                    />
                ) : (
                    <div className="absolute inset-0 grid place-items-center bg-gradient-to-br from-purple-dark to-bg-soft">
                        <div className="text-center">
                            <UserRound className="mx-auto text-gold/40" size={64} strokeWidth={1.2} />
                            <div className="mt-3 text-[10px] tracking-[0.4em] uppercase text-gold font-bold">Not Pictured</div>
                        </div>
                    </div>
                )}
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/80 to-transparent" />
            </div>
            <div className="p-5">
                <div className="text-[10px] tracking-[0.3em] uppercase text-gold font-bold">{c.title}</div>
                <div className="h-display text-2xl mt-2">{c.name}</div>
                {hasBio && (
                    <div className="mt-3">
                        <p
                            className={`text-ink text-sm leading-relaxed transition-all ${open ? "" : "line-clamp-2"}`}
                            data-testid={`coach-bio-${i}`}
                        >
                            {c.bio}
                        </p>
                        <button
                            type="button"
                            onClick={() => setOpen((v) => !v)}
                            className="mt-2 inline-flex items-center gap-1 text-gold text-[10px] tracking-[0.3em] uppercase font-bold hover:text-gold-bright"
                            data-testid={`coach-bio-toggle-${i}`}
                        >
                            {open ? "Read Less" : "Read More"}
                            <ChevronDown
                                size={12}
                                className={`transition-transform ${open ? "rotate-180" : ""}`}
                            />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default function Coaches() {
    const [coaches, setCoaches] = useState([]);
    useEffect(() => { api.get("/coaches").then((r) => setCoaches(r.data)); }, []);

    return (
        <div data-testid="coaches-page" className="grain">
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">The Front Office</div>
                    <h1 className="h-display text-6xl md:text-8xl">Coaches & Staff</h1>
                    <p className="text-ink text-lg mt-5 max-w-xl">The minds and hands behind the kingdom.</p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-5 md:px-10 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {coaches.map((c, i) => (
                        <StaffCard key={c.id} c={c} i={i} />
                    ))}
                </div>
                {coaches.length === 0 && <div className="text-center text-ink py-20">No staff yet.</div>}
            </section>

            <PressInquiryForm />
        </div>
    );
}
